import request from 'utils/request'

import { MCBQS040InitRequest } from 'types/MCBQS040/MCBQS040InitRequest'
import { MCBQS040CreateRequest } from 'types/MCBQS040/MCBQS040CreateRequest'


export const initMCBQS040Api = (requestdata: MCBQS040InitRequest) =>
  request({
    url: "/MCBQS040/init",
    method: 'post',
    data: requestdata
  })

export const createApi = (requestdata: MCBQS040CreateRequest) =>
  request({
    url: "/MCBQS040/create",
    method: 'post',
    data: requestdata
  })




